export default {
  data () {
    return {
      isLoading: false,

      items: [],
      pagination: {
        pageNumber: 1,
        pageSize: 10,
        totalCount: 0
      }
    }
  },

  /**
   * load items and after that set watchers.
   */
  created () {
    this.loadItems()

    this.$nextTick(() => {
      this.$watch(() => this.pagination.pageNumber, this.loadItems)
      this.$watch(() => this.pagination.pageSize, this.reloadItems)
    })
  },

  methods: {
    /**
     * Default empty array
     */
    getItems () {
      return Promise.resolve([])
    },

    /**
     * Default map array
     *
     * @param {Array} items
     */
    mapItems (items) {
      return Promise.resolve(items)
    },

    /**
     *
     * Set selected page
     *
     * @param {String} selectedPageNumber
     */
    onPageNumberSelect (selectedPageNumber) {
      this.pagination.pageNumber = selectedPageNumber
    },

    /**
     * Reset page and reload items.
     */
    reloadItems () {
      // Pagination
      if (this.pagination.pageNumber === 1) {
        this.loadItems()
      } else {
        this.pagination.pageNumber = 1
      }
    },

    /**
     * Load items
     */
    loadItems () {
      this.isLoading = true

      this.getItems().then(result => {
        const { pageNumber, pageSize } = this.pagination

        this.mapItems(result.slice((pageNumber - 1) * pageSize, pageNumber * pageSize)).then((items) => {
          this.items = items
          this.pagination.totalCount = result.length
        }).finally(() => {
          this.isLoading = false
        })
      })
    }
  }
}
